import { AppSettings } from '../AppSettings';
import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class SecService {
  constructor(private http: Http) { }

  generate(dateOfBirth: string, gender: String) {
    // this.createAuthorizationHeader(headers);
    //        alert(dateOfBirth.split('/').join('-')); //1234/12/12
    //    alert(gender);
    return this.http.get(AppSettings.SERVICE_ENDPOINT + '/api/codes?dateOfBirth='
      + dateOfBirth + '&gender=' + gender + '&sort=-index&limit=1').map((response: Response) => {
        // login successful if there's a jwt token in the response
        //      alert(response.json()[0].code);
        let index = -1;

        if (Object.keys(response.json()).length > 0) {
          index = response.json()[0].index;
        }
        index++;
        let i = index % 1000;
        let ch = Number((index / 1000).toFixed(0));
        let arr = ['V', 'A', 'B', 'C'];
        if ('Female' == gender) {
          //          ch += 13;
          arr = ['Q', 'J', 'E', 'A', 'B', 'C'];
        } else if ('Male' == gender) {
          //          ch += 13;
          arr = ['G', 'N', 'T', 'A', 'B', 'C'];
        }

        //        let code = dateOfBirth + String.fromCharCode(97 + ch).toUpperCase() + this.pad(i);
        let code = dateOfBirth + arr[ch] + this.pad(i);
        localStorage.setItem('currentCode', code + '');
        localStorage.setItem('currentIndex', index + '');

      });

  }

  store(jsonS: any) {
    let headers = new Headers();
    // this.createAuthorizationHeader(headers);
    headers.append('Content-Type', 'application/json');
    //    alert(dateOfBirth.split('/').join('-')); //1234/12/12
    return this.http.post(AppSettings.SERVICE_ENDPOINT + '/api/codes', jsonS, {
      headers: headers
    }).map((response: Response) => {
      // login successful if there's a jwt token in the response
      //      alert(response);

    });

  }

  pad(n) {
    return (n < 10) ? ('00' + n) : (n < 100) ? ('0' + n) : n;
  }

  createAuthorizationHeader(headers: Headers) {
    headers.append('Authorization', 'Basic ' +
      btoa('a20e6aca-ee83-44bc-8033-b41f3078c2b6:c199f9c8-0548-4be79655-7ef7d7bf9d20'));
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
  }
}


// WEBPACK FOOTER //
// ./src/app/sec/sec.service.ts